// The "All Off" / "All On" bars that cap the touch-screen stack.
//
// Flutter clips each bar with a quadratic-bezier arc (fourTouchFunctions.dart
// TopSemiCircleClipper / BottomSemiCircleClipper): the top bar bulges upward,
// the bottom bar bulges downward. CSS can't express that shape, so the same two
// paths are reproduced with an inline SVG clip-path in objectBoundingBox units —
// `Q 0.5,0 1,1` for the top bar and `Q 0.5,1 1,0` for the bottom one, which are
// the Dart curves verbatim.
//
// The gradient direction and text colours are the Dart's too: red #F72119 on the
// "All Off" bar with a white glow, green #66FF00 on "All On" with a black one.

import React from 'react';
import { Box, ButtonBase, Typography, useTheme } from '@mui/material';

export default function AllBar({
  variant, // 'off' (top) | 'on' (bottom)
  onClick,
  width,
  height,
  fontSize,
  padding,
}) {
  const theme = useTheme();
  const c = theme.sli;
  const isOff = variant === 'off';

  const clipId = isOff ? 'sli-bar-top' : 'sli-bar-bottom';
  const path = isOff ? 'M0,1 Q0.5,0 1,1 L0,1 Z' : 'M0,0 Q0.5,1 1,0 L0,0 Z';

  return (
    <>
      <Box component="svg" width={0} height={0} sx={{ position: 'absolute' }}>
        <defs>
          <clipPath id={clipId} clipPathUnits="objectBoundingBox">
            <path d={path} />
          </clipPath>
        </defs>
      </Box>

      <ButtonBase
        onClick={onClick}
        sx={{
          width,
          height,
          clipPath: `url(#${clipId})`,
          background: isOff
            ? `linear-gradient(to left, ${c.button}, ${c.text})`
            : `linear-gradient(to right, ${c.button}, ${c.text})`,
          boxShadow: isOff ? '4px 4px 8px 1px rgba(0,0,0,0.2)' : 'none',
          display: 'flex',
          alignItems: isOff ? 'flex-end' : 'flex-start',
          justifyContent: 'center',
        }}
      >
        <Typography
          sx={{
            p: `${padding}px`,
            fontSize,
            fontWeight: 700,
            color: isOff ? '#F72119' : '#66FF00',
            textShadow: isOff
              ? '2px 2px 4px rgba(255,255,255,0.6)'
              : '2px 2px 4px rgba(0,0,0,0.7)',
          }}
        >
          {isOff ? 'All Off' : 'All On'}
        </Typography>
      </ButtonBase>
    </>
  );
}
